<template>
  <div>
    <Header />
    <main>
      <div class="user" v-if="user">
        <div class="section-frame">
          <div class="user-frame">
            <div class="user-section">
              <div class="user-photo">
                <img
                  :src="
                    user.image_url
                      ? $mediaUrl(user.image_url)
                      : require('../assets/images/user.png')
                  "
                  alt=""
                />
                <label for="editImg"
                  ><img src="../assets/images/camera-solid.svg" alt=""
                /></label>
                <input
                  @change="userUpdate($event)"
                  type="file"
                  accept=".png, .jpg, .jpeg"
                  id="editImg"
                />
              </div>
              <h3 class="user-name">{{ user.first_name }}</h3>
              <ul class="user-menu">
                <li :class="{ 'user-active-page': $route.path === '/user' }">
                  <router-link to="/user"
                    ><i class="fa-book"></i>
                    <div>{{ $t("my_courses") }}</div>
                  </router-link>
                </li>
                <li :class="{ 'user-active-page': $route.path === '/desires' }">
                  <span
                    class="user-notification"
                    v-if="wishlist && wishlist.length"
                    >{{ wishlist.length }}</span
                  >
                  <router-link to="/desires"
                    ><i class="fa-save-fill"></i>
                    <div>{{ $t("wishlist") }}</div>
                  </router-link>
                </li>
                <li
                  :class="{
                    'user-active-page': $route.path === '/certificates',
                  }"
                >
                  <router-link to="/certificates"
                    ><i class="fa-certificate"></i>
                    <div>{{ $t("my_certificates") }}</div>
                  </router-link>
                </li>
                <!--<li :class="{'user-active-page' : $route.path === '/bonus'}">
                  <router-link to="/bonus"><i class="fa-bonus"></i>
                    <div>{{ $t('bonuses') }}</div>
                  </router-link>
                </li>-->
                <li :class="{ 'user-active-page': $route.path === '/profile' }">
                  <router-link to="/profile">
                    <i class="fa-user"></i>
                    <div>{{ $t("profile") }}</div>
                    <svg
                      class="invalid"
                      v-if="
                        user.first_name === '' ||
                        user.last_name === '' ||
                        user.full_name === '' ||
                        user.date_birth === '' ||
                        user.login === '' ||
                        user.city === ''
                      "
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 192 512"
                    >
                      <path
                        fill="currentColor"
                        d="M20 424.229h20V279.771H20c-11.046 0-20-8.954-20-20V212c0-11.046 8.954-20 20-20h112c11.046 0 20 8.954 20 20v212.229h20c11.046 0 20 8.954 20 20V492c0 11.046-8.954 20-20 20H20c-11.046 0-20-8.954-20-20v-47.771c0-11.046 8.954-20 20-20zM96 0C56.235 0 24 32.235 24 72s32.235 72 72 72 72-32.235 72-72S135.764 0 96 0z"
                      ></path>
                    </svg>
                  </router-link>
                </li>
                <li class="user-link-out js-popup-out">
                  <a @click.prevent="logoutPopup = true" href=""
                    ><i class="fa-out"></i>{{ $t("exit") }}</a
                  >
                </li>
              </ul>
            </div>
            <router-view />
          </div>
        </div>
      </div>
      <div class="user" v-else>
        <div class="section-frame">
          <div class="user-frame">
            <div class="user-section">
              <ul class="user-menu"></ul>
            </div>
            <router-view />
          </div>
        </div>
      </div>
    </main>
    <MobileBar @active="popupUser" />
    <PopupUser @active="popupUser" :active="active" />
    <Footer />
    <DeleteCoursePopup
      @close="logoutPopupFunc"
      :logout-event="true"
      @logout="logout"
      v-if="logoutPopup"
    />
  </div>
</template>

<script>
import Header from "@/components/Header";
import MobileBar from "@/components/MobileBar";
import Footer from "@/components/Footer";
import PopupUser from "@/components/PopupUser";
import DeleteCoursePopup from "@/components/DeleteCoursePopup";

export default {
  data() {
    return {
      active: false,
      logoutPopup: false,
    };
  },
  methods: {
    popupUser(e) {
      this.active = e;
    },
    logoutPopupFunc(e) {
      this.logoutPopup = e;
    },
    async userUpdate(event) {
      let user = new FormData();
      user.append("image", event.target.files[0]);
      user.append("first_name", this.user.first_name);
      user.append("last_name", this.user.last_name);
      user.append("full_name", this.user.full_name);
      user.append(
        "phone",
        this.user.phone.replace(/-|\s/g, "").replace(/[{()}]/g, ""),
      );
      user.append("country", "Узбекистан");
      user.append("city", this.user.city);
      user.append("date_birth", this.user.date_birth || "");

      try {
        await this.$store.dispatch("profileUpdate", user);
        await this.$store.dispatch("getUserCredentials");
      } catch (e) {
        console.log(e);
      }
    },
    async logout(e) {
      if (e) {
        await this.$store.dispatch("logout");
        await this.$router.push("/login");
      }
    },
  },

  computed: {
    user() {
      return this.$store.getters.getUserCredentials;
    },
    wishlist() {
      return this.$store.getters.getWishlist;
    },
    notification() {
      return this.$store.getters.getNotifications;
    },
    lang() {
      return this.$store.getters.lang;
    },
  },
  components: {
    Header,
    MobileBar,
    Footer,
    PopupUser,
    DeleteCoursePopup,
  },
};
</script>
